
export const PERMISSIONS = {

    scopes: 1,
    createScope: 3,
    editScope: 4,
    deleteScope: 5,
    createOrganizationalArea: 6,
    changeScopeStatus: 7,
    viewScope: 8,
    impacts: 51,
    createImpact: 52,
    editImpact: 53,
    deleteImpact: 54,
    impactStatus: 55,
    viewImpactMeasures: 56,
    editImpactMeasures: 57,
    assets: 101,
    createAsset: 102,
    importAssets: 103,
    downloadAssetTemplate: 104,
    uploadAssetEvidence: 105,
    viewAssetCriticity: 106,
    editAssetCriticity: 107,
    relateAssets: 108,
    removeAssetRelation: 109,
    editAsset: 110,
    quickAssetEdit: 111,
    deleteAsset: 112,
    viewAsset: 113,
    viewAssetsFromTemplate: 114,
    saveAssetFromTemplate: 115,
    viewAssetsRelatedToAsset: 116,
    threats: 151,
    createThreat: 152,
    importThreats: 153,
    downloadThreatTemplate: 154,
    editThreat: 155,
    deleteThreat: 156,
    viewThreat: 157,
    relateAssetsToThreats: 158,
    removeThreatAssetsRelation: 159,
    viewAssetsRelatedToThreat: 160,
    viewVulnerabilitiesRelatedToThreat: 161,
    relateVulnerabilitiesToThreats: 162,
    removeThreatVulnerabilitiesRelation: 163,
    vulnerabilities: 201,
    createVulnerability: 202,
    importVulnerabilities: 203,
    downloadVulnerabilityTemplate: 204,
    relateThreatsToVulnerability: 205,
    removeVulnerabilityThreatRelation: 206,
    relateAssetsToVulnerability: 207,
    removeVulnerabilityAssetsRelation: 208,
    editVulnerability: 209,
    deleteVulnerability: 210,
    viewVulnerability: 211,
    viewAssetsVulnerabilities: 212,
    viewThreatsVulnerabilities: 213,
    riskRecognition: 251,
    viewThreatsRiskRecognition: 252,
    editThreatsRiskRecognition: 253,
    viewVulnerabilitiesRiskRecognition: 254,
    editVulnerabilitiesRiskRecognition: 255,
    risks: 256,
    viewRiskDetails: 258,
    setAssetCriticity: 259,
    identifyRelatedThreats: 260,
    editRisk: 261,
    viewRiskControls: 262,
    addRiskControl: 263,
    viewRiskVulnerabilities: 264,
    riskMaps: 265,
    viewRiskMapsControls: 266,
    createRiskMapsControls: 267,
    treatmentPlan: 268,
    viewControlDetails: 269,
    createControlFollowUp: 270,
    viewControlFollowUp: 271,
    editControlFollowUp: 272,
    deleteControlFollowUp: 273,
    controlsFollowing: 274,
    viewRiskDetailsControlsFollowing: 275,
    viewRiskControlsControlsFollowing: 276,
    deleteControls: 277,
    createControls: 278,
    editControls: 279,
    createControlFollowUpOnControlsFollowing: 280,
    viewControlFollowUpOnControlsFollowing: 281,
    viewRiskProbability: 284,
    editRiskProbability: 285,
    viewImpactRisks: 286,
    editRiskImpactMeasures: 287,
    probabilityMeasures: 351,
    editProbabilityMeasures: 352,
    parameters: 401,
    createParameter: 402,
    editParameter: 403,
    viewParameter: 404,
    deleteParameter: 405,
    users: 451,
    createUser: 452,
    editUser: 453,
    deleteUser: 454,
    viewUsers: 455,
    changeUserStatus: 456,
    changeUserPassword: 457,
    roles: 501,
    createRole: 502,
    editRole: 503,
    deleteRole: 504,
    viewRoles: 505,
    companies: 551,
    createCompany: 552,
    editCompany: 553,
    deleteCompany: 554,
    viewCompanies: 555,
    relateUsersToCompany: 556,
    removeUserCompanyRelation: 557,
    viewUserCompanyRelation: 558,
    addUserToCompany: 559,
    viewCompanyUsers: 560,
    plans: 601,
    createPlan: 602,
    editPlan: 603,
    deletePlan: 604,
    viewPlans: 605,
    addons: 616,
    createAddon: 617,
    editAddon: 618,
    deleteAddon: 619,
    viewAddons: 620,
    subscriptions: 626,
    approveSubscription: 627,
    rejectSubscription: 628,
    hardCaps: 621,
    createHardCap: 622,
    editHardCap: 623,
    viewHardCaps: 624,
    mySubscription: 631,
    contractAddon: 632,
    cancelAddon: 633,
    requestPlanChange: 634,
    viewPlanHistory: 635,
};